<template>
  <div class="content">
    <PersonaIntroSection />
    <PersonaTheVoiceOfGloSection />
    <PersonaGridSection />
      
  </div>
</template>

<script lang="ts">
import PersonaGridSection from '@/components/VerbalIdentityPage/sections/persona/PersonaGridSection.vue';
import PersonaIntroSection from '@/components/VerbalIdentityPage/sections/persona/PersonaIntroSection.vue';
import PersonaTheVoiceOfGloSection from '@/components/VerbalIdentityPage/sections/persona/PersonaTheVoiceOfGloSection.vue';
import { Component, Vue } from 'vue-property-decorator'


@Component({
  components: {
    PersonaIntroSection,
    PersonaTheVoiceOfGloSection,
    PersonaGridSection     
  }
})
export default class PersonaView extends Vue {}
</script>

<style lang="scss"></style>
